<template>
    <div class="table-responsive mb-0">
        <table class="table table-sm table-bordered mb-0">
            <tbody>
                <tr>
                    <th class="w-50">Personel</th>
                    <td class="w-50">{{ $safe(value,'FullName') }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bolder text-primary">Hesaplanan Tutar</td>
                    <td class="text-right">{{ convertMoney(calculatedTotal) }} ₺</td>
                </tr>
                <tr>
                    <td class="font-weight-bolder text-primary">Eklenen Tutar</td>
                    <td class="text-right">
                        <v-currency-input class="text-right form-control-sm" :value="added" v-on:update-value="currencyAmount => {added = currencyAmount; setAmount()}"></v-currency-input>
                    </td>
                </tr>
                <tr>
                    <td class="font-weight-bolder text-secondary">Bu Ay BES İçin Ödenecek Toplam Tutar</td>
                    <td class="font-weight-bolder text-right">{{ convertMoney(total) }} ₺</td>
                </tr>
                <tr>
                    <td colspan="2" class="bg-light p-50">
                        <textarea v-model="value.Description" class="form-control resize-none" rows="3" placeholder="Açıklama"></textarea>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import Additional from '@/utilities/additional'
import { BSpinner } from 'bootstrap-vue';

export default {
    components:{
        VCurrencyInput,
        BSpinner
    },
    props:{
        value:Object,
        salaryPaymentDate:String | null
    },
    data(){
        return {
            added:null
        }
    },
    methods:{
        convertMoney(n){
            return Additional.ConvertMoney(n)
        },
        setAmount(){
            this.value.Amount = this.total
        }
    },
    computed:{
        calculatedTotal(){
            return (this.value.CalculatedAmount || 0)
        },
        total(){
            return this.calculatedTotal + (this.added || 0)
        }
    }
}
</script>